<template>
<div id="news">
    <h1>News</h1>
    <div>
        <table>
            <tbody>
                <tr v-for="(item, index) in newNews" :key="index">
                    <td><strong>[{{ item.month }} {{ item.year }}]</strong></td>
                    <td><span v-html="item.message"></span></td>
                </tr>
            </tbody>
        </table>
        <div class="show-more-container">
            <a class="show-more" href="javascript:void(0)" @click="showOldNews = !showOldNews">
                ---- show {{ showOldNews ? "less" : "more" }} ----
            </a>
        </div>
        <table v-if="showOldNews">
        <tbody>
            <tr v-for="(item, index) in oldNews" :key="'old-' + index">
                <td><strong>[{{ item.month }} {{ item.year }}]</strong></td>
                <td><span v-html="item.message"></span></td>
            </tr>
        </tbody>
        </table>
    </div>
</div>
</template>
  
<script>
export default {
    name: 'News',
    data() {
        return {
            showOldNews: false, // State to toggle the old news
            news: [
                {
                    "month": "Sep.",
                    "year": 2025,
                    "message": "My first work <a href='https://cuhk-arise.github.io/CodeCrash/'>CodeCrash</a> is accepted to <a href='https://neurips.cc/Conferences/2025'>NeurIPS'25</a>!",
                    "old": false,
                },
                {
                    "month": "Jan.",
                    "year": 2025,
                    "message": "Our paper <a href='https://arxiv.org/abs/2403.11807'>GAMA-Bench</a> is accepted to <a href='https://iclr.cc'>ICLR'25</a>!",
                    "old": false,
                },
                {
                    "month": "Sep.",
                    "year": 2024,
                    "message": "Our paper <a href='https://arxiv.org/abs/2308.03656'>EmotionBench</a> is accepted to <a href='https://neurips.cc/Conferences/2024'>NeurIPS'24</a>!",
                    "old": false,
                },
                {
                    "month": "Sep.",
                    "year": 2024,
                    "message": "Our paper <a href='https://arxiv.org/abs/2305.19926'>ScaleReliability</a> is accepted to <a href='https://2024.emnlp.org'>EMNLP'24</a> main conference!",
                    "old": false,
                },
                {
                    "month": "Aug.",
                    "year": 2024,
                    "message": "I join the <a href='http://ariselab.cse.cuhk.edu.hk/'>ARISE Lab</a> as a Ph.D. student in <a href='https://www.cse.cuhk.edu.hk/'>CSE</a> Department at <a href='https://www.cuhk.edu.hk/english/index.html'>CUHK</a>, supervised by Prof. <a href='https://www.cse.cuhk.edu.hk/lyu/home'>Michael R. Lyu</a>.",
                    "old": false,
                },
                {
                    "month": "Jul.",
                    "year": 2024,
                    "message": "I graduate from <a href='https://www.ws.cuhk.edu.hk'>Lee Woo Sing College</a> at <a href='https://english.pku.edu.cn/'>CUHK</a>!",
                    "old": false,
                },
                {
                    "month": "Jun.",
                    "year": 2024,
                    "message": "Our graduation thesis wins the <a href='https://www.asmpt.com'>ASMPT</a> Technology Silver Award in a competition among 6 universities in HK!",
                    "old": true,
                },
                {
                    "month": "May",
                    "year": 2024,
                    "message": "I am visiting the <a href='https://warwick.ac.uk/fac/sci/physics/research/condensedmatt/ultrafastphotonics/emmasthzgroup/'>THz Group</a> in the <a href='https://warwick.ac.uk/fac/sci/physics/'>Physics Department</a> at the <a href='https://warwick.ac.uk/'>University of Warwick</a>, working with Prof. <a href='https://warwick.ac.uk/fac/sci/physics/staff/academic/emacpherson/'>Emma MacPherson</a>.",
                    "old": true,
                },
                {
                    "month": "Jan.",
                    "year": 2024,
                    "message": "Our paper <a href='https://arxiv.org/abs/2310.01386'>PsychoBench</a> is accepted to <a href='https://iclr.cc/Conferences/2024'>ICLR'24</a> and will have an <font color='red'><b>ORAL</b></font> presentation!",
                    "old": true,
                },
                {
                    "month": "May.",
                    "year": 2023,
                    "message": "My undergraduate <a href='https://www.erg.cuhk.edu.hk/erg/Elite'>ELITE Stream</a> Graduation Thesis is supervised by Prof. <a href='https://www.cse.cuhk.edu.hk/lyu/home'>Michael R. Lyu</a> and advised by Mr. <a href='https://penguinnnnn.github.io/'>Jen-tse Huang</a>.",
                    "old": true
                },
            ]
        };
    },
    methods: {
        showOldNews() {
            this.showOldNews = !this.showOldNews;
        },
    },
    computed: {
        newNews() {
            return this.news.filter((item) => !item.old);
        },
        oldNews() {
            return this.news.filter((item) => item.old);
        },
  },
};
</script>
  
<style>
#news {
  font-size: 16px;
  width: 1000px;
  margin: 50px auto;
}

table {
  font-size: 18px;
  line-height: 1.5;
}

.show-more-container {
    text-align: center;
}

.show-more {
    font-size: 18px;
    display: inline-block;
    text-decoration: none;
    cursor: pointer;
}

td:first-child {
  width: 150px;
  padding-right: 20px;
  text-align: right;
}

#news a {
    color: #3670C9;
    cursor: pointer;
}

#news a:hover {
    color: #FF5733;
}
</style>